<div class="modal-body form-modal-body">
  <div class="skylark-modal-header">
    <h4>Cancellation of Schedule</h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>
  <div class="form-group" [formGroup]="form">
    <p>
      Worker has requested this time slot be cancelled.
    </p>


    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label><b>Scheduled Start Time</b></label>
          <p>{{scheduleItem.startTime | date: 'dd/MM/yyyy HH:mm'}}</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label><b>Scheduled End Time</b></label>
          <p>{{scheduleItem.endTime | date: 'dd/MM/yyyy HH:mm'}}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label><b>Note</b></label>
          <p>{{scheduleItem.reason}}</p>
        </div>
      </div>
    </div>
    <hr>

    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label><b>Cancelled By</b></label>
          <p>{{scheduleItem.cancelledItem.createdBy}}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label><b>Cancelled On</b></label>
          <p>{{scheduleItem.cancelledItem.createdDate | date: 'dd/MM/yyyy HH:mm'}}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label><b>Reason for cancelling</b></label>
          <p>{{scheduleItem.cancelledItem.reason}}</p>
        </div>
      </div>
    </div>
  </div>

  <p-footer>
    <ng-container *ngIf="!showRejectionForm">
      <button type="button" class="btn btn-secondary btn-round float-right" [disabled]="saveInProgress" (click)="reject()">Keep</button>
      <button type="button" class="btn btn-danger btn-round float-right" [disabled]="saveInProgress" (click)="approve()">Delete</button>
    </ng-container>
  </p-footer>
</div>
